<nz-button-group *ngIf="!forReport">
  <div [class]="'button-container' + (isCardView ? '-card' :'')" *ngIf="moduleStructure !== undefined && (!forSection ||
  (forSection && section.Type === 1)
 )">
    <ng-container *ngFor="let button of buttonsToDisplay">
      <button [class]="button.AdditionalInformationParsed.ButtonClass"
        [nzType]="button.AdditionalInformationParsed.IsPrimary? 'primary' : 'default'" *ngIf="((!forSection && button.SectionId == null) || (forSection && button.SectionId == sectionId))
      && ((renderBeforeContent && button.AdditionalInformationParsed.RenderBeforeSectionContent) || (!renderBeforeContent && !button.AdditionalInformationParsed.RenderBeforeSectionContent))
      && (button.OptionsSQLStatementId == null || button.OptionsSQLStatementId === 0)" nz-button
        (click)="executeCustomAction(button)" [nzLoading]="button.IsLoading">
        <i *ngIf="button.AdditionalInformationParsed.ButtonIcon != null && button.AdditionalInformationParsed.ButtonIcon !== undefined && button.AdditionalInformationParsed.ButtonIcon !== ''"
          nz-icon [nzType]="button.AdditionalInformationParsed.ButtonIcon" nzTheme="outline"></i>

        {{ button.AdditionalInformationParsed.Label | locale }}
      </button>

      <button [nzLoading]="button.IsLoading" nz-button nz-dropdown [nzDropdownMenu]="menu"
        [class]="button.AdditionalInformationParsed.ButtonClass"
        [nzType]="button.AdditionalInformationParsed.IsPrimary? 'primary' : 'default'" *ngIf="((!forSection && button.SectionId == null) || (forSection && button.SectionId == sectionId))
      && ((renderBeforeContent && button.AdditionalInformationParsed.RenderBeforeSectionContent) || (!renderBeforeContent && !button.AdditionalInformationParsed.RenderBeforeSectionContent))
      && (button.OptionsSQLStatementId != null && button.OptionsSQLStatementId !== 0)" nzPlacement="bottomRight">
        {{ button.AdditionalInformationParsed.Label | locale }}
      </button>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li *ngFor="let option of button.Options" nz-menu-item>
            <a nz-button [nzLoading]="button.IsLoading" [class]="button.AdditionalInformationParsed.ButtonClass"
              (click)="executeCustomAction(button,option.Code)" [disabled]="button.IsLoading">{{option.Name |
              locale}}</a>
          </li>
        </ul>
      </nz-dropdown-menu>

    </ng-container>
  </div>

  <div [class]="'button-container' + (isCardView ? '-card' :'')"
    *ngIf="moduleStructure !== undefined && ((forSection && !section.AdditionalInformationParsed.CustomButtonIsGrouped && forLine !== -1))">
    <ng-container *ngFor="let button of buttonsToDisplay">
      <button [class]="button.AdditionalInformationParsed.ButtonClass"
        [nzType]="button.AdditionalInformationParsed.IsPrimary? 'primary' : 'default'" *ngIf="((!forSection && button.SectionId == null) || (forSection && button.SectionId == sectionId))
      && ((renderBeforeContent && button.AdditionalInformationParsed.RenderBeforeSectionContent) || (!renderBeforeContent && !button.AdditionalInformationParsed.RenderBeforeSectionContent))
      && (button.OptionsSQLStatementId == null || button.OptionsSQLStatementId === 0)" nz-button
        (click)="executeCustomAction(button)" [nzLoading]="button.IsLoading">
        <i *ngIf="button.AdditionalInformationParsed.ButtonIcon != null && button.AdditionalInformationParsed.ButtonIcon !== undefined && button.AdditionalInformationParsed.ButtonIcon !== ''"
          nz-icon [nzType]="button.AdditionalInformationParsed.ButtonIcon" nzTheme="outline"></i>

        {{ button.AdditionalInformationParsed.Label | locale }}
      </button>

      <button [nzLoading]="button.IsLoading" nz-button nz-dropdown [nzDropdownMenu]="menu"
        [class]="button.AdditionalInformationParsed.ButtonClass"
        [nzType]="button.AdditionalInformationParsed.IsPrimary? 'primary' : 'default'" *ngIf="((!forSection && button.SectionId == null) || (forSection && button.SectionId == sectionId))
      && ((renderBeforeContent && button.AdditionalInformationParsed.RenderBeforeSectionContent) || (!renderBeforeContent && !button.AdditionalInformationParsed.RenderBeforeSectionContent))
      && (button.OptionsSQLStatementId != null && button.OptionsSQLStatementId !== 0)" nzPlacement="bottomRight">
        {{ button.AdditionalInformationParsed.Label | locale }}
      </button>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li *ngFor="let option of button.Options" nz-menu-item>
            <a nz-button [nzLoading]="button.IsLoading" [class]="button.AdditionalInformationParsed.ButtonClass"
              (click)="executeCustomAction(button,option.Code)" [disabled]="button.IsLoading">{{option.Name |
              locale}}</a>
          </li>
        </ul>
      </nz-dropdown-menu>

    </ng-container>
  </div>

  <div [class]="'button-container' + (isCardView ? '-card' :'')"
    *ngIf="moduleStructure !== undefined && buttonsToDisplay.length !== 0 && ((forSection && section.AdditionalInformationParsed.CustomButtonIsGrouped) || !forSection)">
    <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" *ngIf="forLine !== -1">
      <i class="fa-light fa-circle-chevron-down"></i>
    </a>

    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <ng-container *ngFor="let button of buttonsToDisplay">
          <ng-container
            *ngIf="((!forSection && button.SectionId == null) || (forSection && button.SectionId == sectionId))
            && ((renderBeforeContent && button.AdditionalInformationParsed.RenderBeforeSectionContent) || (!renderBeforeContent && !button.AdditionalInformationParsed.RenderBeforeSectionContent))">

            <li *ngIf="button.OptionsSQLStatementId == null || button.OptionsSQLStatementId === 0" nz-menu-item
              (click)="executeCustomAction(button)" [nzDisabled]="button.IsLoading">
              <i *ngIf="button.AdditionalInformationParsed.ButtonIcon" nz-icon
                [nzType]="button.AdditionalInformationParsed.ButtonIcon" nzTheme="outline"></i>
              {{ button.AdditionalInformationParsed.Label | locale }}
            </li>

            <li *ngIf="button.OptionsSQLStatementId != null && button.OptionsSQLStatementId !== 0" nz-submenu>
              <span title>
                {{ button.AdditionalInformationParsed.Label | locale }}
              </span>
              <ul>
                <li *ngFor="let option of button.Options" nz-menu-item
                  (click)="executeCustomAction(button, option.Code)" [nzDisabled]="button.IsLoading">
                  {{ option.Name | locale }}
                </li>
              </ul>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </nz-dropdown-menu>
  </div>

  <div [class]="'button-container' + (isCardView ? '-card' :'')"
    *ngIf="moduleStructure !== undefined && ((forSection && section.AdditionalInformationParsed.CustomButtonIsGrouped && forLine === -1))">
    <ng-container *ngFor="let button of buttonsToDisplay">
      <button [class]="button.AdditionalInformationParsed.ButtonClass"
        [nzType]="button.AdditionalInformationParsed.IsPrimary? 'primary' : 'default'" *ngIf="button.AdditionalInformationParsed.WorkingOnSelectedLines && setOfCheckedId.size > 0 && ((!forSection && button.SectionId == null) || (forSection && button.SectionId == sectionId))
      && ((renderBeforeContent && button.AdditionalInformationParsed.RenderBeforeSectionContent) || (!renderBeforeContent && !button.AdditionalInformationParsed.RenderBeforeSectionContent))
      && (button.OptionsSQLStatementId == null || button.OptionsSQLStatementId === 0)" nz-button
        (click)="executeCustomAction(button)" [nzLoading]="button.IsLoading">
        <i *ngIf="button.AdditionalInformationParsed.ButtonIcon != null && button.AdditionalInformationParsed.ButtonIcon !== undefined && button.AdditionalInformationParsed.ButtonIcon !== ''"
          nz-icon [nzType]="button.AdditionalInformationParsed.ButtonIcon" nzTheme="outline"></i>

        {{ button.AdditionalInformationParsed.Label | locale }}
      </button>

      <button [class]="button.AdditionalInformationParsed.ButtonClass"
        [nzType]="button.AdditionalInformationParsed.IsPrimary? 'primary' : 'default'" *ngIf="!button.AdditionalInformationParsed.WorkingOnSelectedLines && ((!forSection && button.SectionId == null) || (forSection && button.SectionId == sectionId))
      && ((renderBeforeContent && button.AdditionalInformationParsed.RenderBeforeSectionContent) || (!renderBeforeContent && !button.AdditionalInformationParsed.RenderBeforeSectionContent))
      && (button.OptionsSQLStatementId == null || button.OptionsSQLStatementId === 0)" nz-button
        (click)="executeCustomAction(button)" [nzLoading]="button.IsLoading">
        <i *ngIf="button.AdditionalInformationParsed.ButtonIcon != null && button.AdditionalInformationParsed.ButtonIcon !== undefined && button.AdditionalInformationParsed.ButtonIcon !== ''"
          nz-icon [nzType]="button.AdditionalInformationParsed.ButtonIcon" nzTheme="outline"></i>

        {{ button.AdditionalInformationParsed.Label | locale }}
      </button>
      <button [nzLoading]="button.IsLoading" nz-button nz-dropdown [nzDropdownMenu]="menu"
        [class]="button.AdditionalInformationParsed.ButtonClass"
        [nzType]="button.AdditionalInformationParsed.IsPrimary? 'primary' : 'default'" *ngIf="((!forSection && button.SectionId == null) || (forSection && button.SectionId == sectionId))
      && ((renderBeforeContent && button.AdditionalInformationParsed.RenderBeforeSectionContent) || (!renderBeforeContent && !button.AdditionalInformationParsed.RenderBeforeSectionContent))
      && (button.OptionsSQLStatementId != null && button.OptionsSQLStatementId !== 0)" nzPlacement="bottomRight">
        {{ button.AdditionalInformationParsed.Label | locale }}
      </button>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li *ngFor="let option of button.Options" nz-menu-item>
            <a nz-button [nzLoading]="button.IsLoading" [class]="button.AdditionalInformationParsed.ButtonClass"
              (click)="executeCustomAction(button,option.Code)" [disabled]="button.IsLoading">{{option.Name |
              locale}}</a>
          </li>
        </ul>
      </nz-dropdown-menu>

    </ng-container>
  </div>
</nz-button-group>

<nz-button-group *ngIf="forReport">
  <ng-container *ngFor="let button of buttons">
    <button nz-button (click)="executeReportCustomAction(button)" [nzLoading]="button.IsLoading">
      {{ button.AdditionalInformationParsed.Label | locale }}
    </button>
  </ng-container>
</nz-button-group>
